(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4559],{

/***/ 6645:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transportation",
      function () {
        return __webpack_require__(9711);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4288);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1138);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6647);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5285);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2213);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9677);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SHOW_RESOURCES = 3;
const getInitials = function(name) {
    let separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    return name.split(separator).map((part)=>{
        var _part_;
        return ((_part_ = part[0]) === null || _part_ === void 0 ? void 0 : _part_.toUpperCase()) || "";
    }).join("");
};
const truncateContent = (content, maxLength)=>{
    const text = content.replace(/<[^>]+>/g, ""); // Strip HTML tags
    return text.length > maxLength ? "".concat(text.substring(0, maxLength), "...") : text;
};
const MoreResources = (param)=>{
    let { filterId =[]  } = param;
    const [resources, setResources] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [hasFetched, setHasFetched] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!hasFetched) {
            const fetchResources = async ()=>{
                try {
                    const response = await fetch("/api/getBlogPosts");
                    const data = await response.json();
                    const filteredResources = data.filter((item)=>!filterId.includes(item.id)).sort(()=>0.5 - Math.random()).slice(0, SHOW_RESOURCES);
                    setResources(filteredResources);
                } catch (error) {
                    console.error("Failed to fetch resources:", error);
                }
            };
            fetchResources();
            setHasFetched(true); // Ensure fetch only happens once
        }
    }, [
        filterId,
        hasFetched
    ]); // `filterId` ensures the fetch updates if `filterId` changes
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h4",
                gutterBottom: true,
                children: "Read Next"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                container: true,
                spacing: 2,
                sx: {
                    py: 2
                },
                children: resources.map((resource, idx)=>{
                    var _resource_images;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                href: "/topic/" + resource.id,
                                children: [
                                    ((_resource_images = resource.images) === null || _resource_images === void 0 ? void 0 : _resource_images.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        image: resource.images[0].url,
                                        sx: {
                                            height: 150,
                                            objectFit: "cover"
                                        }
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        component: "img",
                                        sx: {
                                            height: 150,
                                            objectFit: "contain"
                                        },
                                        image: "/KCC-Logo.webp"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            py: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "body1",
                                                noWrap: true,
                                                sx: {
                                                    width: "100%",
                                                    maxWidth: "100%"
                                                },
                                                children: resource.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "caption",
                                                children: resource.author.displayName || getInitials(resource.author.name)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "caption",
                                                children: console.log(JSON.stringify(resource))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "subtitle2",
                                                color: "text.secondary",
                                                component: "div",
                                                children: moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(resource.published).fromNow()
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, "more_resources_card_".concat(idx));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreResources);


/***/ }),

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1391);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1138);
/* harmony import */ var _Utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7209);






const NextBreadcrumbs = (param)=>{
    let { title  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const [breadcrumbs, setBreadcrumbs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (router) {
            const linkPath = router.asPath.split("/");
            linkPath.shift();
            const pathArray = linkPath.map((path, i)=>{
                return {
                    breadcrumb: path,
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    if (!breadcrumbs) {
        return null;
    }
    const breadcrumbsLength = breadcrumbs.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        "aria-label": "breadcrumb",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                underline: "hover",
                color: "inherit",
                href: "/",
                children: "Home"
            }),
            breadcrumbs.map((breadcrumb, i)=>{
                // const text = convertBreadcrumb(breadcrumb.breadcrumb);
                const text = (0,_Utils_utils__WEBPACK_IMPORTED_MODULE_4__/* .ConvertPathText */ .gO)(breadcrumb.breadcrumb);
                if (breadcrumbsLength - 1 == i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        color: "text.primary",
                        children: title ? title : text
                    }, "Breadcrumb_" + i);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    underline: "hover",
                    color: "inherit",
                    href: breadcrumb.href,
                    children: text
                }, "Breadcrumb_" + i);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextBreadcrumbs);


/***/ }),

/***/ 9711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Transportation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(4288);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(1138);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./component/Leaflet.module.css
var Leaflet_module = __webpack_require__(9879);
var Leaflet_module_default = /*#__PURE__*/__webpack_require__.n(Leaflet_module);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet.css
var leaflet = __webpack_require__(5254);
;// CONCATENATED MODULE: ./component/LeafLetMap.jsx




let MapContainer, TileLayer, Marker, Popup, CircleMarker, L, Tooltip, ImageOverlay;
let Bounds, CRS, Proj4, Proj4Leaflet;
const LeafletMap = (props)=>{
    const [show, setShow] = (0,react.useState)(false);
    const [markers, setMarkers] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (show && "shown" in props) {
            setTimeout(()=>{
                props.shown();
            }, 1000);
        }
    }, [
        show
    ]);
    (0,react.useEffect)(()=>{
        const leafletres = (async ()=>await __webpack_require__.e(/* import() */ 7378).then(__webpack_require__.bind(__webpack_require__, 7378)))().then((i)=>i);
        fetch("/api/getMapData?variable=".concat(props.variable)).then((res)=>res.json()).then((json)=>{
            leafletres.then((reactLeaflet)=>{
                MapContainer = reactLeaflet.MapContainer;
                TileLayer = reactLeaflet.TileLayer;
                Marker = reactLeaflet.Marker;
                Popup = reactLeaflet.Popup;
                CircleMarker = reactLeaflet.CircleMarker;
                Tooltip = reactLeaflet.Tooltip;
                // CRS = require("leaflet").CRS;
                Proj4 = __webpack_require__(9492);
                Proj4Leaflet = __webpack_require__(1751);
                L = __webpack_require__(5243);
                // delete L.Icon.Default.prototype._getIconUrl;
                // L.Icon.Default.mergeOptions({
                //   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
                //   iconUrl: require("leaflet/dist/images/marker-icon.png"),
                //   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                // });
                Bounds = new L.LatLngBounds([
                    39.33,
                    -89.34
                ], [
                    36.29,
                    -82.1
                ]);
                CRS = new L.Proj.CRS("EPSG:3088", "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 " + // bigger positive x shifts everything to the rightbigger negative y shifts everything down
                "+lat_0=36.33333333333334 +lon_0=-85.75 +x_0=344500 +y_0=-486500 " + "+ellps=GRS80 +datum=NAD83 +units=m +no_defs", {
                    // bigger first number pulls points closer together make the second number half the first, the third half the second, etc.
                    resolutions: [
                        2664,
                        1332,
                        666,
                        333
                    ]
                });
                const tMarkers = [];
                for(let stid in json){
                    const data = json[stid];
                    const latLon = [
                        Number(data.Lat),
                        Number(data.Lon)
                    ];
                    //   const MARKER_FILL_COLOR = "#EFEFEF",
                    //   MARKER_HIGHLIGHT_COLOR = "#00ccff",
                    //   MARKER_BORDER_COLOR = "#222222",
                    tMarkers.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CircleMarker, {
                        center: latLon,
                        color: "#222222",
                        fill: true,
                        fillColor: "#EFEFEF",
                        fillOpacity: 0.8,
                        radius: 8,
                        weight: 2,
                        opacity: 0.9,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                            permanent: true,
                            className: (Leaflet_module_default()).nopadding,
                            opacity: 0.85,
                            direction: "top",
                            children: parseFloat(data[props.variable]).toFixed(2)
                        })
                    }, stid));
                }
                setMarkers(tMarkers);
                setShow(true);
            });
        });
    }, [
        props
    ]);
    return show && MapContainer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer, {
        center: [
            37.875,
            -85.805
        ],
        zoom: 2,
        style: {
            height: "480px"
        },
        crs: CRS,
        bounds: Bounds,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer, {
                // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url: "https://www.kymesonet.org/imgs/tiles/".concat(props.variable, "/{z}/{x}/{y}.png?t=").concat(Math.ceil(Date.now() / 60000)),
                noWrap: true,
                minZoom: 2,
                maxZoom: 3,
                bounds: Bounds
            }),
            markers
        ]
    }) : "Refresh to load map";
};
/* harmony default export */ var LeafLetMap = (LeafletMap);

// EXTERNAL MODULE: ./component/MoreResources.jsx
var MoreResources = __webpack_require__(1384);
// EXTERNAL MODULE: ./component/NextBreadcrumbs.jsx
var NextBreadcrumbs = __webpack_require__(9733);
// EXTERNAL MODULE: ./component/Page.jsx + 4 modules
var Page = __webpack_require__(4374);
;// CONCATENATED MODULE: ./pages/transportation.js






function Transportation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "./background/transportation.jpg",
                style: {
                    width: "100%",
                    maxHeight: 250,
                    objectFit: "cover",
                    objectPosition: "center bottom"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    py: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextBreadcrumbs/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                children: "Transportation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    textAlign: "justify",
                                    py: 3
                                },
                                children: "Kentucky has nearly 80,000 miles of roadway, over 14,000 bridges, and over 2,500 miles of railway, critical infrastructure for maintaining the state's economic vitality and well-being. Yet weather and climate are common impediments impacting transportation; severe winds, heavy rainfall, snow and ice, and fog can cause major travel problems. Long-term climatic changes, such as increased rainfall and higher temperatures, can shorten pavement life and undermine bridge supports. More appropriate roadway design, pavement materials, and salting operations, carefully determined utilizing local climate information, can save millions of dollars annually in operations and maintenance costs. More accurate, more local weather and climate data are key to safer roads and highways across the Commonwealth."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                children: "Current Rainfall"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeafLetMap, {
                                variable: "PRCP"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                children: "Current Windspeed"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeafLetMap, {
                                variable: "WSPD"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreResources/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 9879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nopadding":"Leaflet_nopadding__ybA5m"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,9269,6770,9412,5446,6087,4836,4374,9774,2888,179], function() { return __webpack_exec__(6645); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);